import { getUrlWithoutQueryOrHash } from "./domains";
import { serializeStructuredStackTrace, StructuredStackTrace } from "./serializeStructuredStackTrace";

// type PrepareStackTraceFn = NonNullable<(typeof Error)["prepareStackTrace"]>;
// export type StructuredStackTrace = Parameters<PrepareStackTraceFn>[1];
export type CallSite = NonNullable<StructuredStackTrace[0]>;

export class StackArrayGenerator extends Error {
	readonly structuredStackTrace: StructuredStackTrace;

	stackTraceLimit: number;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	constructor({depth = 100, topFnToIgnore=StackArrayGenerator}: {depth?: number, topFnToIgnore?: Function}) {
		super();
		this.stackTraceLimit = depth;
		const originalPrepareStackTrace = Error.prepareStackTrace!;
		const originalLimit = Error.stackTraceLimit;
		try {
			Error.stackTraceLimit = depth;
			this.stackTraceLimit = depth;
			Error.prepareStackTrace = function (error, structuredStackTrace) {
				return structuredStackTrace;
			};
			const hasStack = {} as {stack: StructuredStackTrace};
			Error.captureStackTrace(hasStack, topFnToIgnore);
			this.structuredStackTrace = hasStack.stack;
		} finally {
			Error.prepareStackTrace = originalPrepareStackTrace;
			Error.stackTraceLimit = originalLimit;
		}
	}
}

export class StackTextGenerator extends Error {
	public readonly stackText: string;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	constructor({depth = 100, topFnToIgnore=StackTextGenerator}: {depth?: number, topFnToIgnore?: Function}) {
		super();
		const originalLimit = Error.stackTraceLimit;
		try {
			Error.stackTraceLimit = depth;
			const hasStack = {} as {stack: string};
			Error.captureStackTrace(hasStack, topFnToIgnore);
			const {stack} = hasStack;
			const stackText = typeof stack === "string" ? stack : JSON.stringify(stack);
			this.stackText = stackText.startsWith("Error\n") ? stackText.slice(6) : stackText;
		} finally {
			Error.stackTraceLimit = originalLimit;
		}
	}
}

export const getParameterlessUrlsOfCallers = ({stackArray}: {stackArray: ReturnType<typeof serializeStructuredStackTrace>}) => ([
	...new Set<string>(
		stackArray
			.map(({fileName}) => fileName == null ? undefined : getUrlWithoutQueryOrHash(fileName))
			.filter( url => typeof url === "string")
			.filter( url => ['http', 'ws'].some( prefix => url.startsWith(prefix)))
	)]
);

export const getCodeLocation = (
	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	topFnToIgnore: Function | undefined,
) => {
	const {structuredStackTrace} = new StackArrayGenerator({topFnToIgnore});
//	const {stackText} = new StackTextGenerator({topFnToIgnore});
	const stackArray = serializeStructuredStackTrace(structuredStackTrace);
	let windowLocationHref: string = "";
	try {
		windowLocationHref = window?.location?.href ?? "";
	} catch {
		// Ignore errors
	}
//	const firstPartyRegisteredDomain = getRegisteredDomain(windowLocationHref);
	const codeUrls = getParameterlessUrlsOfCallers({stackArray})
//		.filter((hostname) => getRegisteredDomain(hostname) !== firstPartyRegisteredDomain);
	return {stackArray, windowLocationHref, codeUrls}
}

export type CodeLocation = ReturnType<typeof getCodeLocation>;
export const hasCodeLocation = (obj: unknown): obj is CodeLocation =>
	typeof obj === "object" && obj != null &&
	"stackText" in obj && "stackArray" in obj && "windowLocationHref" in obj && "codeUrls" in obj &&
	Array.isArray((obj as {stackArray?: unknown[]}).stackArray) &&
	typeof obj.stackText === "string" &&
	typeof obj.windowLocationHref === "string" &&
	Array.isArray(obj.codeUrls);

export const codeLocationToParameterlessUrlsDeepestCodeFirst = (codeLocation: CodeLocation) => {
	return [...new Set<string>(codeLocation.stackArray.map( x => {
		try {
			return x.fileName == null ? undefined : getUrlWithoutQueryOrHash( x.fileName )
		} catch {
			return undefined;
		}
	}).filter( x => x != null) )]
	.filter( url => ['http', 'ws'].find( prefix => url.startsWith(prefix)) != null);
}

export const hasCodeUrls = (o: object): o is {codeUrls: string[]} =>
	"codeUrls" in o &&
	Array.isArray(o.codeUrls) &&
	o.codeUrls.every( x => typeof x === "string");
;
